module.exports = new __parcel__URL__("testimonial-wonchul.e435ed72.webp").toString();